import React from 'react';
import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const jobsDockOffset = 56;

const DetailModalShell = ({
  open,
  onClose,
  title,
  externalId,
  loading,
  loadingLabel,
  left,
  right,
  actions,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: 'none',
          m: { xs: 1, md: 2 },
          mb: { xs: `calc(${jobsDockOffset}px + 8px)`, md: `calc(${jobsDockOffset}px + 16px)` },
          maxHeight: { xs: `calc(100% - ${jobsDockOffset}px - 16px)`, md: `calc(100% - ${jobsDockOffset}px - 32px)` },
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', minHeight: 0, height: '100%' }}>
        {loading ? (
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              bgcolor: 'rgba(255,255,255,0.6)',
              zIndex: 10,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexDirection: 'column',
              gap: 1,
            }}
          >
            <CircularProgress />
            {loadingLabel ? <Typography color="text.secondary">{loadingLabel}</Typography> : null}
          </Box>
        ) : null}
        <DialogTitle
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            pr: 1,
            flexShrink: 0,
          }}
        >
          <Box sx={{ minWidth: 0 }}>
            <Typography variant="h6" noWrap>
              {title || 'Details'}
            </Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              ID: {externalId || '—'}
            </Typography>
          </Box>
          <IconButton onClick={onClose} aria-label="Close details">
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers sx={{ p: 0, minHeight: 0, flex: 1 }}>
          <Stack direction={{ xs: 'column', md: 'row' }} sx={{ height: '100%', minHeight: 0 }}>
            <Box
              sx={{
                flex: { xs: '0 0 auto', md: '0 0 60%' },
                borderRight: { md: (theme) => `1px solid ${theme.palette.divider}` },
                p: { xs: 1.5, sm: 2, md: 3 },
                minHeight: 0,
                overflowY: 'auto',
              }}
            >
              {left}
            </Box>
            <Box sx={{ flex: 1, p: { xs: 1.5, sm: 2, md: 3 }, minHeight: 0, overflowY: 'auto', display: 'flex', flexDirection: 'column', gap: 2 }}>
              {right}
            </Box>
          </Stack>
        </DialogContent>
        {actions ? <DialogActions>{actions}</DialogActions> : null}
      </Box>
    </Dialog>
  );
};

export default DetailModalShell;
